import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EventService } from "../event-service/event.service";
import { RememberService } from "../remember/remember.service";
import { GetStartedModalComponent } from "./get-started-modal.component";

@Injectable()
export class GetStartedModalService {
  constructor(
    public modalService: NgbModal,
    private eventService: EventService,
    private rememberService: RememberService,
  ) {}

  public open() {
    const modalRef = this.modalService.open(GetStartedModalComponent, {
      backdropClass: "modal-backdrop__semi-transparent",
      centered: true,
      size: "md",
      windowClass: "modal-content__border",
    });
    modalRef.dismissed.subscribe(() => {
      this.rememberService.set("getStartedModalDismissed", true);
      this.eventService.publish("show-install-airbrake-btn", true);
    });
  }
}
